import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './locales/translation';

const resources = translations;
console.log('resources', resources)
i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: 'zhTW',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    react: {
      wait: true,
    }
  });

export default i18n;

// // this as another instance of i18n
// // mainly for address, where '.' will got escaped
// // this instance will use "::" to escape keys
// export const i18n_addr = i18n.createInstance()
// .init({
//   resources,
//   fallbackLng: 'zhTW',
//   debug: true,

//   interpolation: {
//     escapeValue: false, // not needed for react as it escapes by default
//   },

//   keySeparator: '::',

//   react: {
//     wait: true,
//   }
// });